import React, { useRef, useState } from 'react';

const CameraScanner = ({ onCapture }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [cameraOn, setCameraOn] = useState(false);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = stream;
      setCameraOn(true);
    } catch (err) {
      console.error('Camera not available:', err);
      alert('Camera not available. Please upload an image instead.');
    }
  };

  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);

    const dataUrl = canvas.toDataURL('image/png');
    onCapture(dataUrl);
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      onCapture(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div style={{ textAlign: 'center' }}>
      {!cameraOn ? (
        <>
          <button className='camera-button' onClick={startCamera}>Start Camera</button>
          <p>or upload image:</p>
          <input className='camera-button' type="file" accept="image/*" onChange={handleUpload} />
        </>
      ) : (
        <>
          <video ref={videoRef} autoPlay style={{ width: '100%', maxWidth: '400px' }} />
          <button onClick={captureImage}>Capture</button>
        </>
      )}
      <canvas ref={canvasRef} style={{ display: 'none' }} />
    </div>
  );
};

export default CameraScanner;
